export const searchLabel = {
    placeholder: "Search Ticket"
}